import { InjectionToken } from '@angular/core';

/** Feature flags controlling which grid UI affordances are enabled. */
export interface GridFeatures {
  /** Leading row-action column (e.g. fly-to map button). */
  readonly rowAction: boolean;
  /** Global / bounding-box scope toggle in the panel toolbar. */
  readonly scopeToggle: boolean;
  /** Type-specific column zones, discriminator chips, and info banner. */
  readonly discriminatorColumns: boolean;
  /** Group bar and drag-to-group affordances. */
  readonly grouping: boolean;
  /** Per-column header filter menus. */
  readonly columnFilters: boolean;
  /** Columns visibility popover on the grid toolbar. */
  readonly columnsPopover: boolean;
  /** Dark / light theme toggle in the panel toolbar. */
  readonly themeToggle: boolean;
  /** Maximize / restore panel button. */
  readonly maximizeButton: boolean;
  /** Close panel button. */
  readonly closeButton: boolean;
  /**
   * Enables the panel selection-mode toggle. Checkboxes and the selection bar stay
   * hidden until the user turns selection UI on (or the host sets `selectionUiEnabled`).
   */
  readonly rowSelection: boolean;
}

/**
 * Type-discriminator field for inventory hosts (CAR).
 * Bind this on the grid/panel and on `GRID_ORCHESTRATION_OPTIONS.discriminatorField`
 * — the shared default is empty so standalone hosts do not inherit `elementType`.
 */
export const INVENTORY_DISCRIMINATOR_FIELD: string = 'elementType';

/** Full inventory + map integration preset (CAR app). Row selection stays off until opted in. */
export const INVENTORY_GRID_FEATURES: GridFeatures = {
  rowAction: true,
  scopeToggle: true,
  discriminatorColumns: true,
  grouping: true,
  columnFilters: true,
  columnsPopover: true,
  themeToggle: false,
  maximizeButton: true,
  closeButton: true,
  rowSelection: false
};

/** Standalone preset for non-inventory, non-map contexts. */
export const STANDALONE_GRID_FEATURES: GridFeatures = {
  rowAction: false,
  scopeToggle: false,
  discriminatorColumns: false,
  grouping: true,
  columnFilters: true,
  columnsPopover: true,
  themeToggle: false,
  maximizeButton: true,
  closeButton: true,
  rowSelection: true
};

export const GRID_FEATURES: InjectionToken<GridFeatures> = new InjectionToken<GridFeatures>('GRID_FEATURES', {
  factory: (): GridFeatures => STANDALONE_GRID_FEATURES
});
